import type { NodeType } from "prosemirror-model";

import { EmojiCompletion } from "../../EmojiCompletion";

import { completionPlugin } from "~/client/components/richTextEditor/plugins/CompletionPlugin";
import { triggerCharacter } from "~/client/components/richTextEditor/utils/triggerCharacter";
import { isCustomEmoji } from "~/client/features/emoji/isCustomEmoji";
import { UnicodeEmoji } from "~/client/features/emoji/UnicodeEmoji";

type Args = {
  emojiNode: NodeType;
  unicodeEmojiNode: NodeType;
  disabledIn?: NodeType;
};

export const emojiCompletionPlugin = ({ emojiNode, unicodeEmojiNode, disabledIn }: Args) =>
  completionPlugin(
    new EmojiCompletion(),
    (item) => {
      if (isCustomEmoji(item.src)) {
        return emojiNode.create({ alt: item.name, src: item.src });
      } else {
        const unicodeEmoji = new UnicodeEmoji(item.name);
        return unicodeEmojiNode.create({ class: unicodeEmoji.getClassName(), text: item.src, title: item.name });
      }
    },
    triggerCharacter(":", { allowSpaces: false, disabledIn: disabledIn }),
  );
